module.exports = __webpack_public_path__ + "static/laser_md-5e65e71e9824e823934179b85d91a1bf.webp";